import { c as _c } from "react/compiler-runtime";
import DOMPurify from 'dompurify';
import { ContactNotesWithPagination, useContactNotesOffsetPagination } from 'modules/crm/pipeline/contact-card/note/hooks/use-notes-with-offset-pagination';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { ContactId } from '../../types/contact-interface';
import { PinIcon } from '@systemeio/ui/icons';
namespace ContactNotes {
  export interface Props {
    contactId: ContactId;
  }
}
export function ContactNotes(t0) {
  const $ = _c(28);
  const {
    contactId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    pagination,
    setLimit,
    setPagination
  } = usePagination(true);
  const t1 = !!contactId;
  let t2;
  if ($[0] !== contactId || $[1] !== limit || $[2] !== pagination || $[3] !== t1) {
    t2 = {
      contactId,
      isFetchAllowed: t1,
      limit,
      pagination
    };
    $[0] = contactId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data
  } = useContactNotesOffsetPagination(t2);
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.contact_page.notes.note_content");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = [{
      key: "content",
      widthPercent: 100,
      header: t3,
      onRender: _temp
    }];
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const columns = t4;
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.crm_pipeline.contact_modal.note");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <h2 className="h-[42px] text-[17px] font-bold">{t5}</h2>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== pagination || $[14] !== setPagination) {
    t7 = {
      pagination,
      setPagination
    };
    $[13] = pagination;
    $[14] = setPagination;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== limit || $[17] !== setLimit) {
    t8 = {
      limit,
      setLimit
    };
    $[16] = limit;
    $[17] = setLimit;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== columns || $[20] !== data || $[21] !== t7 || $[22] !== t8) {
    t9 = <Table columns={columns} data={data} paginator={t7} limiter={t8} rowIdParser={_temp2} />;
    $[19] = columns;
    $[20] = data;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== data || $[25] !== t6 || $[26] !== t9) {
    t10 = <ListingLayout counter={false} data={data} title={t6} type="compact">{t9}</ListingLayout>;
    $[24] = data;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp2(row) {
  return row.paginationId;
}
function _temp(t0) {
  const {
    content,
    isPinned
  } = t0;
  return <div className="flex items-center justify-between gap-1.5"><p className="[&>p>a]:text-brand-primary hyphens-auto whitespace-normal [&>p>strong]:font-bold" dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(content)
    }} />{isPinned && <PinIcon className="fill-brand-primary h-[18px] w-[18px] shrink-0" />}</div>;
}